/**
 * Offers view — F5 Build Spec (your offer builder).
 * Connects to offerPlatform (D1-backed) or Gate register.
 */

import { useState, useEffect } from "react";
import { getClients, applyMembrane } from "../lib/api-clients";

export function OffersView({ isOperator }: { isOperator: boolean }) {
  const [offers, setOffers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ title: "", description: "", url: "" });

  useEffect(() => {
    const clients = getClients();
    if (!clients) { setLoading(false); return; }
    clients.control.listOffers()
      .then((res: any) => setOffers(applyMembrane(res?.offers || [], isOperator)))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [isOperator]);

  async function create() {
    if (!form.title.trim()) return;
    const clients = getClients();
    if (!clients) return;
    try {
      await clients.control.createOffer({ title: form.title, description: form.description, url: form.url });
      setForm({ title: "", description: "", url: "" });
      setShowCreate(false);
      const res: any = await clients.control.listOffers();
      setOffers(applyMembrane(res?.offers || [], isOperator));
    } catch (err: any) { setError(err.message); }
  }

  if (loading) return <div className="loading">Loading offers…</div>;

  return (
    <div className="view">
      <div className="view-header">
        <span className="eyebrow">{applyMembrane("F5", isOperator)}</span>
        <h1>Offers</h1>
        <button className="btn-primary" onClick={() => setShowCreate(!showCreate)}>New offer</button>
      </div>
      {error && <div className="error-state">{error}</div>}
      {showCreate && (
        <div className="card form-card">
          <div className="form-row">
            <label>Title</label>
            <input className="text-input" value={form.title} onChange={(e) => setForm({...form, title: e.target.value})} placeholder="Your offer" />
          </div>
          <div className="form-row">
            <label>Description</label>
            <textarea className="text-input" value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} placeholder="What you're offering…" rows={3} />
          </div>
          <div className="form-row">
            <label>URL (optional)</label>
            <input className="text-input" value={form.url} onChange={(e) => setForm({...form, url: e.target.value})} placeholder="https://yourdomain.com/offer" />
          </div>
          <button className="btn-primary" onClick={create}>Create offer</button>
        </div>
      )}
      {offers.length === 0 ? (
        <div className="empty-state">No offers yet. {applyMembrane("Use the F5 Build Spec to create your first offer.", isOperator)}</div>
      ) : (
        <div className="card-grid">
          {offers.map((o: any, i: number) => (
            <div key={i} className="card">
              <div className="card-title">{o.title}</div>
              <div className="card-meta">
                {o.url && <a href={o.url} target="_blank" rel="noopener">View →</a>}
                <span className="badge" data-status={o.status || "active"}>{o.status || "active"}</span>
              </div>
              {o.description && <p className="card-desc">{o.description}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
